'use client';

import { EmptyState } from '@yanolja-rnd/nol-design-system';

import { IcErrorH72 } from '@yanolja-rnd/nol-icons';

interface NotFoundProps {
  refetch: () => void;
}

export const NotFound = ({ refetch }: NotFoundProps) => {
  return (
    <div className="mt-40 flex h-full w-full justify-center bg-static-white">
      <EmptyState
        icon={IcErrorH72}
        title="화면을 불러오지 못했어요"
        pcType="pcLegacySize"
        buttons={[
          {
            content: '다시 시도하기',
            onClick: refetch,
          },
        ]}
      />
    </div>
  );
};
